import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
//import { MyUrl } from "../../../App";
import "ag-grid-enterprise";

import axios from "axios";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import sourcing from "../../Images/sourcing.png";
var MyArray = [];
export default function GlobalThirdTable({
  SendDataToFirstTable,
  startDate,
  endDate,
}) {
  let history = useHistory();

  const items = localStorage.getItem("Token");
  // Remove double quotes
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  console.log(aa);
  const [Value, setValue] = React.useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  // const url = `http://localhost:3001/?jwt=${jwtToken}`; //`${GoToDSP}/?jwt=${jwtToken}`;
  // window.open(url, "_blank");
  const BtnCellRenderer = (rowData) => {
    const { data } = rowData;
    const { sourceId, otherData } = data; // Assuming 'otherData' is the additional data you want to display

    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          paddingTop: 2,
        }}
      >
        <a
          onClick={() => {
            const url = `/SourceManagement/?${sourceId}`;
            // Open the URL in a new browser tab or window
            const newWindow = window.open(url, "_blank");
            // Optionally, you can still push the URL to the history stack
            //history.push(url);
            // Focus on the new window (optional)
            if (newWindow) {
              newWindow.focus();
            }
            //   history.push(`/SourceManagement/?jwt=${aa}`);
          }}
          //href={`http://localhost:3001/?jwt=${aa}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div>
            <img
              src={sourcing}
              style={{ width: "50%", cursor: "pointer" }}
              onClick={() => {}}
            ></img>
          </div>
          {/* <a
            style={{
              color: "green",
              cursor: "pointer",
              border: "1px solid green",
              padding: 5,
              borderRadius: 5,
            }}
            onClick={() => {
              console.log("sss");
            }}
          >
            {" "}
            Source
          </a> */}
        </a>
      </div>
    );
  };
  const [height, width] = useWindowSize();
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    // environmentName: data[i].environment.name,
    // targeting: data[i].targeting,
    // geo: data[i].geo,
    // ad_requests: data[i].ad_requests,
    // ad_opportunities: data[i].ad_opportunities,
    // impressions_good: data[i].impressions_good,
    // fill_rate_ad_requests: data[i].fill_rate_ad_requests,
    // Action: data[i].seatName,
    {
      headerName: "Seat Name",
      flex: width > 766 ? 1 : null,
      field: "seatName",
      filter: true,
      floatingFilter: "agTextColumnFilter",

      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      //   headerCheckboxSelection: true,
      //   headerCheckboxSelectionFilteredOnly: true,
      //   checkboxSelection: true,
    },
    {
      headerName: "Source Id",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "sourceId",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName: "Source Name",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "sourceName",
      //filter: true,
      filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",

      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Environment Name",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "environmentName",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Targeting",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "targeting",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      //cellClassRules: { "green-background": 'data.targeting === "WL"' },
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Geo",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "geo",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Ad Requests",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "ad_requests",
      filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) =>
        `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Ad Opportunities",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "ad_opportunities",
      filter: "agNumberColumnFilter",
      floatingFilter: "agTextColumnFilter",

      headerClass: "my-header-class",
      valueFormatter: (params) =>
        `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName: "Impressions Good",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "impressions_good",
      filter: "agNumberColumnFilter",
      floatingFilter: "agTextColumnFilter",

      headerClass: "my-header-class",
      valueFormatter: (params) =>
        `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      headerName: "Fill Rate Ad Requests",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "fill_rate_ad_requests",
      filter: "agNumberColumnFilter",
      floatingFilter: "agTextColumnFilter",

      headerClass: "my-header-class",

      //   valueFormatter: (params) =>
      //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerClass: "my-header-class",
      width: 100,
      headerName: "Actions",
      field: "sourceId",

      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        clicked: function (field) {
          alert(`${field} was clicked`);
        },
      },
    },
  ]);

  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    rowClassRules: {
      //Targeting
      // apply green to 2008
      "rag-green-outer": function (params) {
        return params.data.Targeting === "WL";
      },
    },
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#86efac" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === SendDataToFirstTable.length
        ? "bottom-row"
        : "";
    },
    // other grid options...
  };

  //   const columnDefs = [
  //     { headerName: "Name", field: "name" },
  //     { headerName: "Value", field: "value" },
  //   ];
  const getRowStyle = (params) => {
    return params.data.targeting === "WL"
      ? { background: "#dcfce7" }
      : { background: "#dbeafe" };
  };
  const containerStyle = useMemo(
    () => ({ width: "100%", height: height - 100 }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);
  return (
    <div style={{}}>
      <div style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <span style={{ color: "#1a1523", fontSize: 18 }}>Dashboard</span>
          <AgGridReact
            cellClassRules={ragCellClassRules}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={SendDataToFirstTable} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection="multiple" // Options - allows click selection of rows
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            onGridReady={onGridReady}
            gridOptions={gridOptions}
            suppressScrollOnNewData={true}
            //getRowHeight={getRowHeight}
            //domLayout="autoHeight"
            pagination={true}
            paginationPageSize={100}
            getRowStyle={getRowStyle}
            paginateChildRows={true}
          />
        </div>{" "}
      </div>{" "}
      <style>
        {`
                  .ag-theme-alpine .ag-root-wrapper {
                    border: none;
                  }
                `}
        {`
                  .my-header-class {
                    background-color: white;
                  }
                `}
        {`
                .green-background {
                  background-color: #86efac !important;
                }`}
        {`
             .ag-header-cell {
              background-color: white;
          }`}
      </style>
    </div>
  );
}
